import { useState, useEffect, useRef, } from "react";
import React from "react";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import Wrapper from "../../components/UI/Wrapper";
import SearchIcon from "@mui/icons-material/Search";
import CryptoJS from 'crypto-js';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JSZip from "jszip";



const ViewPettyCashDetail = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [pettyCashId, setPettyCashId] = useState("");
  const [userdetail, setUserdetail] = useState("");
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const [expenseType, setExpenseType] = useState([]);
  const fileInputRef = useRef(null);  
  const [pettyCash, setPettyCash] = useState([]);

  const [pcDetail, setPcDetail] = useState({
    pettycash_id: "",
    request_date: "",
    approval_date: "",
    relocation_id: "",
    amount: "",
    approval_status: "",
    requested_by: "",
    approved_by: "",
    remark: "",
    approval_remark: "",
    request_type: "",
    attachment: "",
    payment_mode: "",
  });


  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  useEffect(() => {
    const encryptedId = query.get('id');
    if (encryptedId) {
      const bytes = CryptoJS.AES.decrypt(encryptedId, 'dbbworldwidepvtltd');
      setPettyCashId(bytes.toString(CryptoJS.enc.Utf8));
      fetchPettyCashDetails(bytes.toString(CryptoJS.enc.Utf8));
      GetExpenseTypes();
      fetchPettyCashList(bytes.toString(CryptoJS.enc.Utf8));
    }
  }, []);


  const GetExpenseTypes = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };
      const expenseTypeRes = await axios.get(`${baseAPI}adminGet/GetRequestType`, { headers });
      setExpenseType(expenseTypeRes.data.data);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  const fetchPettyCashDetails = async (pettycash_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const pcDetailRes = await axios.get(`${baseAPI}userGet/getUserDetailForPettyCash?pettycash_id=${pettycash_id}`, { headers });
      setUserdetail(pcDetailRes.data.data[0]);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const getRemainingBalanceColor = (balance) => {
    const newBalance = Number(balance);
    if (newBalance > 0) {
      return "#20BF44";
    } else {
      return "#DC3545";
    }
  };

  const fetchPettyCashList = async (pettycash_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const pcDetailRes = await axios.get(`${baseAPI}userGet/GetPettyCashDetail?pettycash_id=${pettycash_id}&relocation_id=0`, { headers });
      setPcDetail(pcDetailRes.data.data[0]);
      setPettyCash(pcDetailRes.data.data[0]);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddPettyCash = async (e) => {
    e.preventDefault();
  
    if (!pcDetail.approval_status || !pcDetail.amount) {
      alert("Please fill all required fields");
      return;
    }
  
    const formData = new FormData();
    formData.append("doc_name", pcDetail.attachment);
  
    let uploadedFileName = "";
    let storedToken;
  
    try {
      storedToken = JSON.parse(localStorage.getItem("token"));
      const uploadResponse = await axios.post(
        `${baseAPI}userpost/UploadOtherDocuments`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      uploadedFileName = uploadResponse.data.data; // adjust if different
    } catch (error) {
      alert("Error uploading file: " + (error.response ? error.response.data : error.message));
      return;
    }
  
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        "Content-Type": "application/json",
      };
  
      const pettyCashPayload = {
        ...pcDetail,
        attachment: uploadedFileName,
      };
  
      const response = await axios.post(`${baseAPI}UserPost/InsertUpdateCmpPettyCash`, pettyCashPayload, { headers });
  
      if (response.status === 200) {
        toast.success("Updated!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        fetchPettyCashList(pettyCashId); // Refresh the petty cash list after update
       
       
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }    
      } else {
        console.error("Unexpected response:", response);
        alert("Error saving expense!");
      }
    } catch (error) {
      console.error("Error saving expense:", error.response ? error.response.data : error.message);
      alert("Error saving expense!");
    }
  };

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;

    if (name === "attachment") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        if (
          file.type === "application/zip" ||
          file.type === "application/x-zip-compressed"
        ) {
          validateZipFile(file, name, e);
        } else {
          getUpdatedImage(file, name);
        }
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setPcDetail({
        ...pcDetail,
        [name]: value,
      });
    }
  }

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
      "application/zip", // ZIP
      "application/x-zip-compressed", // Alternate ZIP MIME type
    ];
    return file && allowedTypes.includes(file.type);
  }

  function validateZipFile(file, name, e) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const zipData = event.target.result;

      // Perform ZIP content validation here
      // This might include extracting the files, verifying file types, etc.
      // Client-side libraries like JSZip can help inspect ZIP files
      try {
        const jszip = new JSZip();
        jszip.loadAsync(zipData).then((zip) => {
          const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
          let isValid = true;

          zip.forEach((relativePath, zipEntry) => {
            const extension = relativePath.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
              isValid = false;
            }
          });

          if (isValid) {
            getUpdatedImage(file, name);
          } else {
            alert("ZIP file contains unsupported file types.");
            e.target.value = null;
          }
        });
      } catch (error) {
        alert("Error reading ZIP file.");
        e.target.value = null;
      }
    };

    reader.readAsArrayBuffer(file);
  }

  function getUpdatedImage(file, name) {
    if (file) {
      setPcDetail({
        ...pcDetail,
        [name]: file, // Store the file object directly
      });
    }
  } 


  return (
    <div>
      <div className="app-container-viewLeadDetails">
        <MiniDrawer />
        <div className="container-fluid container-viewLeadDetails">
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                <b> Petty Cash Details </b> | <HomeOutlinedIcon /> &gt; Accounts
                & Finance{" "}
                <span style={{ fontSize: "20px" }}>&gt; Petty Cash</span>
                <span style={{ fontSize: "20px" }}>
                  &gt; Petty Cash Details
                </span>
              </h1>
            </div>
          </div>
          <Wrapper className="LeadDetails">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <b style={{ textDecoration: "underline" }}>
                  {userdetail.Department} ({userdetail.name})
                </b>
              </div>
              <div>

              </div>
            </div>
          </Wrapper>
          <br />

          {/* ------------------------lead deatil--------------------- */}
          <Wrapper className="LeadDetails">
            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={4}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}> Request Detail </span>
                  </th>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Name</span>
                  </th>
                  <td>
                    <span>{userdetail.name}</span>
                  </td>
                  <th>
                    <span>Department</span>
                  </th>
                  <td>
                    <span>{userdetail.Department}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Designation</span>
                  </th>
                  <td>
                    <span>{userdetail.Designation}</span>
                  </td>
                  <th>
                    <span>Date of Request</span>
                  </th>
                  <td>
                    <span>{userdetail.request_date}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Expense Type</span>
                  </th>
                  <td>
                    <span>{userdetail.expense_type}</span>
                  </td>
                  <th>
                    <span>Fixed Amount</span>
                  </th>
                  <td>
                    <span>{userdetail.fixed_amount}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Requested Amount</span>
                  </th>
                  <td>
                    <span>{userdetail.amount}</span>
                  </td>
                  <th>
                    <span>Remaining Amount</span>
                  </th>
                  <td>
                    <span>{userdetail.remaining_amount}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Account Number</span>
                  </th>
                  <td>
                    <span>{userdetail.account_number}</span>
                  </td>
                  <th>
                    <span>IFSC</span>
                  </th>
                  <td>
                    <span>{userdetail.ifsc}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Manager's Name</span>
                  </th>
                  <td>
                    <span>{userdetail.manager}</span>
                  </td>
                  <th>
                    <span>Manager's Approval</span>
                  </th>
                  <td>
                    <span>{userdetail.manager_approval}</span>
                  </td>
                </tr>
              </table>
            </div>
            <br />

            <div
              style={{
                width: "100%",
                alignItems: "center",
                display: "none",
              }}
            >
              <table className="customerDetailsTable">
                <div className="undefined" style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        padding: "11px 0 0 0",
                        overflowX: "auto",
                      }}
                    >
                      <table>
                        <tr className="docUpload">
                          <th
                            style={{ width: "5%", border: "1px solid #DEE2E6" }}
                          >
                            Sr No.
                          </th>
                          <th
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Voucher Number
                          </th>
                          <th
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Date
                          </th>
                          <th
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Name
                          </th>
                          <th
                            style={{
                              width: "25%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Cash Received
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Description
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Amount
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Remaining Balance
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Remark(if any)
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Related Document
                          </th>
                        </tr>

                        <tr className="documentTable">
                          <td
                            style={{ width: "5%", border: "1px solid #DEE2E6" }}
                          >
                            1
                          </td>
                          <td
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            0000
                          </td>
                          <td
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            12 Dec 2024
                          </td>
                          <td
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Antara
                          </td>
                          <td
                            style={{
                              width: "25%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            2000
                          </td>

                          <td
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            test
                          </td>
                          <td style={{ border: "1px solid #DEE2E6" }}>₹ 990</td>
                          <td
                            style={{
                              color: getRemainingBalanceColor("1000"),
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            ₹ 1000
                          </td>
                          <td style={{ border: "1px solid #DEE2E6" }}>
                            ......
                          </td>
                          <td style={{ border: "1px solid #DEE2E6" }}>
                            <button
                              // onClick={() => nextPage()}
                              style={{
                                height: "30px",
                                width: "38px",
                                backgroundColor: "#E3DCFF",
                                border: "1px solid #E3DCFF",
                              }}
                            >
                              <SearchIcon
                                className="icon"
                                style={{ color: "#5B489D", border: "none" }}
                              />
                            </button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </table>
              <div
                style={{ backgroundColor: "#F0F0F0" }}
                className="text-end p-0"
              >
                <h6
                  className=" px-3"
                  style={{
                    paddingTop: "16px",
                    fontWeight: "600",
                    color: "#6A6A6A",
                  }}
                >
                  Total Reimbursed :{" "}
                  <span style={{ color: "#6A6A6A", fontWeight: "700" }}>
                    ₹ 2,000.00
                  </span>
                </h6>
                <hr className="" style={{ padding: "0px 0px 0px 10px" }} />
                <h6
                  className=" px-3"
                  style={{
                    paddingBottom: "20px",
                    fontWeight: "600",
                    color: "#6A6A6A",
                  }}
                >
                  Total Amount Used :{" "}
                  <span style={{ color: "#6A6A6A", fontWeight: "700" }}>
                    ₹ 2,000.00
                  </span>
                </h6>
              </div>
            </div>
          </Wrapper>
          <br />


          {pettyCash.approval_status === "Requested" ? (
            <Wrapper className="ViewLeadDetails">
              <div>
                <div
                  style={{ paddingTop: "30px", paddingLeft: "20px" }}
                  className="country-form"
                >
                  <div style={{ MarginTop: "20px" }}>
                    <h2
                      className="Venderheading"
                      style={{
                        fontSize: "22px",
                        paddingLeft: "16px",
                        paddingTop: "7px",
                      }}
                    >
                      Add Balance
                    </h2>
                    <table
                      style={{ width: "100%", marginBottom: "70px" }}
                      className="addvendorTable"
                    >
                      <tr
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                        className="tableHeading tableHeading2"
                      >
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          Payment Status
                        </td>
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          Amount
                        </td>
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          Payment Mode
                        </td>
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          Request Type
                        </td>
                      </tr>
                      <tr
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                        className="tableHeading tableHeading2"
                      >
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          <select
                            style={{
                              border: "1px solid #5b489d",
                              width: "98%",
                              borderRadius: "6px",
                              marginLeft: "0px",
                              height: "45px",
                              color: "#6a6a6a",
                              position: "relative",
                            }}
                            className="form-control"
                            name="approval_status"
                            value={pcDetail.approval_status}
                            onChange={(e) => setPcDetail({ ...pcDetail, approval_status: e.target.value })}
                          >
                            <option value="0">Select an option</option>
                            <option value="Requested">Requested</option>
                            <option value="Completed">Completed</option>
                            <option value="Rejected">Rejected</option>

                          </select>
                        </td>
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          <input type="text"
                            style={{
                              border: "1px solid #5b489d",
                              width: "98%",
                              borderRadius: "6px",
                              marginLeft: "0px",
                              height: "45px",
                              color: "#6a6a6a",
                              position: "relative",
                            }}
                            className="form-control"
                            name="amount"
                            value={pcDetail.amount}
                            disabled
                            onChange={(e) => setPcDetail({ ...pcDetail, amount: e.target.value })}
                          >
                          </input>
                        </td>
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          <select
                            style={{
                              border: "1px solid #5b489d",
                              width: "98%",
                              borderRadius: "6px",
                              marginLeft: "6px",
                              height: "45px",
                              color: "#6a6a6a",
                              position: "relative",
                            }}
                            className="form-control"
                            name="payment_mode"
                            required
                            value={pcDetail.payment_mode}
                            onChange={(e) => setPcDetail({ ...pcDetail, payment_mode: e.target.value })}
                          >
                            <option value="0">Select an option</option>
                            <option value="Bank" >Bank</option>
                            <option value="Bank" >Cash</option>
                          </select>
                        </td>
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          <select
                            style={{
                              border: "1px solid #5b489d",
                              width: "98%",
                              borderRadius: "6px",
                              marginLeft: "6px",
                              height: "45px",
                              color: "#6a6a6a",
                              position: "relative",
                            }}
                            className="form-control"
                            name="request_type"
                            required
                            value={pcDetail.request_type}
                            onChange={(e) => setPcDetail({ ...pcDetail, request_type: e.target.value })}
                          >
                            <option value="0">Select an option</option>
                            {expenseType.map((exp) => (
                              <option key={exp.request_type_id} value={exp.request_type_id}>
                                {exp.request_type}
                              </option>
                            ))}
                          </select>
                        </td>

                      </tr>
                      <tr
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                        className="tableHeading tableHeading2"
                      >
                        <td colSpan={2}
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "78px",
                          }}
                        >
                          Related Document
                        </td>
                        <td colSpan={2}
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "78px",
                          }}
                        >
                          Remarks (if any)
                        </td>
                      </tr>
                      <tr
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                        className="tableHeading tableHeading2"
                      >
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          <input style={{
                            border: "1px solid #5b489d",
                            width: "99%",
                            padding: "12px",
                            borderRadius: "6px",
                            marginLeft: "4px",
                            height: "45px",
                            color: "#6a6a6a",
                            position: "relative",
                            marginTop: "73px",
                          }} type="file" class="form-control form-control-expencsems" name="attachment" id="attachment"
                            onChange={handleChangeDoc}
                            ref={fileInputRef} />
                        </td>
                        <td
                          style={{
                            color: "#6a6a6a",
                            fontWeight: "bold",
                            width: "100%",
                            marginTop: "13px",
                          }}
                        >
                          {" "}
                          <input
                            type="text"
                            style={{
                              border: "1px solid #5b489d",
                              width: "99%",
                              padding: "12px",
                              borderRadius: "6px",
                              marginLeft: "4px",
                              height: "45px",
                              color: "#6a6a6a",
                              position: "relative",
                              marginTop: "73px",
                            }}
                            name="approval_remark"
                            placeholder="Please Enter*"
                            required
                            value={pcDetail.approval_remark}
                            onChange={(e) => setPcDetail({ ...pcDetail, approval_remark: e.target.value })}

                          />
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div
                    style={{ width: "100%", paddingTop: "81px" }}
                    className="reset-addCountry-button text-end px-0"
                  >
                    <button
                      onClick={handleAddPettyCash}
                      type="submit"
                      style={{
                        marginRight: "4px",
                        backgroundColor: "#5B489D",
                        color: "white",
                      }}
                    >
                      Update
                      <ToastContainer />
                    </button>
                    <button
                      // onClick={handleSubmit}
                      type="submit"
                      style={{
                        marginRight: "4px",
                        backgroundColor: "white",
                        color: "#F15843",
                        border: "none",
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </Wrapper>
          ) : (
            <Wrapper className="LeadDetails">
              <div className="viewLeadDetails-form">
                <table
                  style={{
                    width: "100%",
                    color: "#6A6A6A",
                    borderRadius: "5px",
                  }}
                >
                  <tr className="viewLeadDetailsHeading">
                    <th
                      colSpan={4}
                      style={{
                        background: "#5B489D",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}> Payment Detail </span>
                    </th>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Payment Issued by</span>
                    </th>
                    <td>
                      <span>{pcDetail.approved_by_name}</span>
                    </td>
                    <th>
                      <span>Date of Approval</span>
                    </th>
                    <td>
                      <span>{pcDetail.approval_date}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Payment Status</span>
                    </th>
                    <td>
                      <span>{pcDetail.approval_status}</span>
                    </td>
                    <th>
                      <span>Amount</span>
                    </th>
                    <td>
                      <span>{pcDetail.amount}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Payment mode</span>
                    </th>
                    <td>
                      <span>{pcDetail.payment_mode}</span>
                    </td>
                    <th>
                      <span>Related Document</span>
                    </th>
                    <td>
                      <span>
                        <a
                          style={{
                            color: "#6a6a6a",
                            textDecoration: "none",
                            cursor: "pointer",
                            fontWeight: "bold",
                            pointerEvents: pcDetail.attachment ? "auto" : "none",
                            opacity: pcDetail.attachment ? 1 : 0.5,
                          }}
                          target="_blank"
                          href={pcDetail.attachment ? `${baseImageURL}Images/Documents/OtherDocs/${pcDetail.attachment}` : "#"}
                          rel="noopener noreferrer"
                        >
                          View Document
                        </a>
                      </span>
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Approval Remark</span>
                    </th>
                    <td colSpan={"3"}>
                      <span>{pcDetail.approval_remark}</span>
                    </td>
                  </tr>


                </table>

              </div>
            </Wrapper>
          )}
          <br />
        </div>
      </div>
    </div>
  );
};

export default ViewPettyCashDetail;
